import { StackMessage, StructStack, readEvent } from "@features/builder/crdt/crdtStructs"

export interface DecodedSnapshot {
  stack: StructStack
  changes: DecodedSnapshotMessage[]
}

export interface DecodedSnapshotMessage {
  messages: StackMessage[]
  author: string
}

export const decodeSnapshot = (graphBin: Uint8Array, messagesBin: Uint8Array): DecodedSnapshot => {
  const stack = new StructStack()
  stack.update(readEvent(graphBin))
  const changes: DecodedSnapshotMessage[] = []
  const data = new DataView(messagesBin.buffer)
  let offset = 0
  let size = 0
  let messageCount = 0
  while (offset < messagesBin.length) {
    // read author size and value
    size = data.getUint32(offset)
    offset += 4
    const author = new TextDecoder().decode(messagesBin.slice(offset, offset + size))
    offset += size
    // read update size and value
    size = data.getUint32(offset)
    offset += 4
    const messages = stack.update(readEvent(messagesBin.slice(offset, offset + size)))
    offset += size
    // push changes
    changes.push({ messages, author })
    messageCount++
  }
  // reverse changes for display
  changes.reverse()
  return { stack, changes }
}
